import React, { useState } from "react";
import moment from "moment";
import { flatten, isEmpty } from "lodash";

import ConfirmDialog from "../components/confirm.component";

import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import TextField from "@material-ui/core/TextField";
import { Button, Paper } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import { MenuItem } from "@material-ui/core";
import { useForm } from "react-hook-form";
import IconButton from "@material-ui/core/IconButton";
import PhotoIcon from "@material-ui/icons/Photo";
import DeleteIcon from "@material-ui/icons/Delete";
import { useUsersList } from "./usersListProvider";
import Autocomplete from "@material-ui/lab/Autocomplete";

const TestimonialForm = ({ testimonial = {}, onSubmit, onDelete }) => {
  const [currentImagePath, setCurrentImagePath] = useState(
    testimonial.image_path
  );
  const [openDialog, setOpenDialog] = useState(false);

  // Queries
  const {
    register,
    handleSubmit,
    getValues,
    setValue,
    formState: { errors },
  } = useForm();

  const usersList = flatten(
    useUsersList().map((user) => {
      return { id: user.id, label: `${user.name} (${user.email})` };
    })
  );

  const testimonialUser = usersList.find(
    (user) => user.id === testimonial.user_id
  );

  const handleImageDissociation = () => {
    setCurrentImagePath(null);
    setValue("image_path", null);
  };

  const handleClickOpen = () => {
    setOpenDialog(true);
  };

  const handleClose = () => {
    setOpenDialog(false);
  };

  const statusOptions = [
    {
      label: "Aprovado",
      value: "Aprovado",
    },
    {
      label: "Pendente",
      value: "Pendente",
    },
    {
      label: "Anulado",
      value: "Anulado",
    },
  ];

  const publishedStatusOptions = [
    {
      label: "Nenhum",
      value: "not_published",
    },
    {
      label: "Homepage",
      value: "homepage",
    },
    {
      label: "Sobre Nós",
      value: "about_us",
    },
  ];

  return (
    <Grid container spacing={4}>
      <ConfirmDialog
        open={openDialog}
        title={"Atenção"}
        message={"Tem a certeza que deseja apagar este testemunho?"}
        handleOk={() => onDelete(testimonial)}
        handleCancel={() => handleClose()}
      />

      <Grid item xs={1}></Grid>
      <Grid item xs={10}>
        <Paper
          style={{
            display: "grid",
            gridRowGap: "20px",
            padding: "20px",
          }}
        >
          <form onSubmit={handleSubmit(onSubmit)}>
            {isEmpty(testimonial) ? (
              <Grid container>
                <Grid item xs={6}>
                  <Typography variant="h5">Novo testemunho</Typography>
                </Grid>
              </Grid>
            ) : (
              <Grid container>
                <Grid item xs={6}>
                  <Typography variant="h5">
                    Testemunho #{testimonial.id} - {testimonialUser.label}
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <Box display="flex" justifyContent="flex-end">
                    <IconButton
                      aria-label="delete"
                      style={{
                        color: "#c62828",
                      }}
                      onClick={() => handleClickOpen()}
                    >
                      <DeleteIcon fontSize="inherit" />
                    </IconButton>
                  </Box>
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="subtitle1">
                    Data de criação:{" "}
                    {moment(testimonial.created_at).format(
                      "YYYY-MM-DD [às] HH:mm"
                    )}
                  </Typography>
                </Grid>
              </Grid>
            )}
            <Grid container spacing={4}>
              {currentImagePath && (
                <>
                  <Grid item xs={12}>
                    <img
                      style={{ marginTop: "15px" }}
                      width="300px"
                      src={"https://laresonline.pt" + testimonial.image_path}
                      alt="testimonial image"
                    ></img>
                  </Grid>
                  <Grid item xs={12}>
                    <Button
                      size="small"
                      variant="outlined"
                      color="secondary"
                      component="span"
                      startIcon={<DeleteIcon />}
                      onClick={() => handleImageDissociation()}
                    >
                      Desassociar imagem
                    </Button>
                  </Grid>
                </>
              )}
              <Grid item xs={12}>
                <input
                  accept="image/*"
                  multiple
                  id="contained-button-file"
                  type="file"
                  style={{ display: "none" }}
                  {...register("file")}
                />
                <label htmlFor="contained-button-file">
                  <Button
                    style={{ marginTop: "15px" }}
                    variant="contained"
                    color="primary"
                    component="span"
                    startIcon={<PhotoIcon />}
                  >
                    Carregar imagem
                  </Button>
                </label>
                {!isEmpty(getValues("file")) && (
                  <Typography variant="subtitle2">
                    Nome do ficheiro: {getValues("file")[0].name}
                  </Typography>
                )}
              </Grid>
              <Grid item xs={4}>
                <Autocomplete
                  disablePortal
                  options={usersList}
                  defaultValue={testimonialUser}
                  onChange={(e, data) => {
                    if (data) {
                      setValue("user_id", data.id);
                    }
                  }}
                  getOptionLabel={(option) => option.label}
                  getOptionSelected={(option, value) => option.id === value.id}
                  filterOptions={(options, state) => {
                    if (state.inputValue.length > 2) {
                      return options.filter((item) =>
                        String(item.label)
                          .toLowerCase()
                          .includes(state.inputValue.toLowerCase())
                      );
                    }
                    return [];
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Utilizador (digite 3+ caracteres)"
                      variant="outlined"
                    />
                  )}
                />
              </Grid>
              <Grid item xs={4}>
                <TextField
                  select
                  fullWidth
                  defaultValue={testimonial.status || "Pendente"}
                  label="Estado"
                  inputProps={register("status", {
                    required: "Please enter status",
                  })}
                  error={errors.status}
                  variant="outlined"
                >
                  {statusOptions.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item xs={4}>
                <TextField
                  select
                  fullWidth
                  defaultValue={testimonial.published_status || "not_published"}
                  label="Localização"
                  inputProps={register("published_status", {
                    required: "Please enter published status",
                  })}
                  error={errors.published_status}
                  variant="outlined"
                >
                  {publishedStatusOptions.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  inputProps={register("subject", {
                    required: "Please enter subject",
                  })}
                  defaultValue={testimonial.subject}
                  error={errors.subject}
                  label="Título"
                  variant="outlined"
                  multiline
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  fullWidth
                  inputProps={register("message", {
                    required: "Please enter message",
                  })}
                  defaultValue={testimonial.message}
                  error={errors.message}
                  label="Testemunho"
                  variant="outlined"
                  multiline
                />
              </Grid>
              <Grid item xs={12}>
                <Box display="flex" justifyContent="flex-end">
                  <Button color="primary" type="submit" variant="contained">
                    Guardar
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </form>
        </Paper>
      </Grid>
    </Grid>
  );
};

export default TestimonialForm;
